<template>
  <v-dialog
    v-model="isOpened"
    data-qa="side-menu-drawer"
    transition="fade-transition"
    fullscreen
    hide-overlay
    attach=""
    content-class="flex-dialog"
  >
    <v-overlay
      :value="isOpened"
      z-index="0"
      @click="isOpened = false"
    />
    <transition
      name="slide-x-transition"
      origin="center center"
      appear
    >
      <aside
        v-show="isOpened"
        data-qa="side-menu-drawer-panel"
        class="side-menu-drawer d-flex flex-column flex-grow-1 overflow-y-auto bg-gray-0 elevation-20 h-100 position-fixed"
        v-on="listeners"
      >
        <div
          data-qa="side-menu-drawer-content"
          class="side-menu-drawer__content d-flex flex-column flex-fill overflow-y-auto custom-scroll"
        >
          <div class="d-flex flex-column flex-fill pa-4">
            <slot
              counter-x-space-class="mx-n4"
              counter-y-space-class="my-n4"
            />
          </div>
        </div>
      </aside>
    </transition>
  </v-dialog>
</template>

<script lang="ts" setup>
import { computed, useListeners } from 'vue'

const props = defineProps<{
  value: boolean
}>()

type Emits = {
  (_event: 'input', _value: boolean): void
}

const emit = defineEmits<Emits>()
const listeners = useListeners()

const isOpened = computed({
  get() {
    return props.value
  },
  set(value: boolean) {
    emit('input', value)
  },
})
</script>

<style lang="scss" scoped>
@import '~www/themes/doctors/common/variables';

:deep(.v-dialog.flex-dialog) {
  display: flex;
  flex-direction: column;
}

.side-menu-drawer {
  left: 0;
  right: auto;
  width: 270px;

  &__content {
    position: relative;
  }
}

.custom-scroll {
  @supports (scrollbar-color: auto) {
    scrollbar-color: $ui-kit-bg-gray-80 $ui-kit-bg-gray-40;
  }

  @supports (selector(::-webkit-scrollbar)) {
    scrollbar-color: auto;

    &::-webkit-scrollbar-thumb {
      border-radius: $border-radius-pill;
      background-color: $ui-kit-bg-gray-60;
    }

    &::-webkit-scrollbar {
      width: 8px;
      border-radius: $border-radius-pill;
      background-color: $ui-kit-bg-gray-40;
    }
  }
}
</style>
